/**
 * PipelineConnector Component
 *
 * Arrow connector between pipeline steps with percentage label.
 */

import { ArrowRight } from 'lucide-react';
import { cn } from '@/lib/utils';

interface PipelineConnectorProps {
  percentage: number | null;
  status: 'green' | 'yellow' | 'red' | 'blocked';
}

const percentColors: Record<string, string> = {
  green: 'text-green-600 dark:text-green-400',
  yellow: 'text-yellow-600 dark:text-yellow-400',
  red: 'text-red-600 dark:text-red-400',
  blocked: 'text-gray-400 dark:text-gray-500'
};

const arrowColors: Record<string, string> = {
  green: 'text-green-500',
  yellow: 'text-yellow-500',
  red: 'text-red-500',
  blocked: 'text-gray-300'
};

export function PipelineConnector({ percentage, status }: PipelineConnectorProps) {
  return (
    <div className="flex flex-col items-center justify-center mx-1 min-w-[40px]">
      {/* Percentage Label */}
      {percentage !== null && (
        <span className={cn(
          'text-xs font-semibold mb-1',
          percentColors[status]
        )}>
          {percentage}%
        </span>
      )}

      {/* Arrow */}
      <ArrowRight className={cn('h-5 w-5', arrowColors[status])} />
    </div>
  );
}
